import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useUser } from './UserContext';
import { db } from '../firebaseConfig';
import { doc, updateDoc, arrayUnion, onSnapshot, collection, getDocs } from 'firebase/firestore';

// Create context
const AchievementContext = createContext();

// List of all available achievements with their criteria
export const ACHIEVEMENTS = [




    {
        id: 'artist',
        title: 'Artist',
        description: 'Draw 10 Games',
        icon: '🏆',
        checkCondition: (userData) => userData?.draws > 10
    },
    {
        id: 'first_victory',
        title: 'First Victory',
        description: 'Win your first ranked match',
        icon: '🏆',
        checkCondition: (userData) => userData?.wins > 0
    },
    {
        id: 'all_i_do_is_win',
        title: 'All I do is win',
        description: 'Win 10 Ranked matches',
        icon: '🏆',
        checkCondition: (userData) => userData?.wins > 10
    },
    {
        id: 'suffering_from_success',
        title: 'Suffering from success',
        description: 'Win 100 Ranked matches',
        icon: '🏆',
        checkCondition: (userData) => userData?.wins > 100
    },






    {
        id: 'know_it_all',
        title: 'Know it all',
        description: 'Answer 100 questions correctly',
        icon: '🏆',
        checkCondition: (userData) => userData?.questionsCorrect > 100
    },
    {
        id: 'quiz_whiz',
        title: 'Quiz Whiz',
        description: 'Answer 500 questions correctly',
        icon: '🏆',
        checkCondition: (userData) => userData?.questionsCorrect > 500
    },
    {
        id: 'brainiac',
        title: 'Brainiac',
        description: 'Answer 1000 questions correctly',
        icon: '🏆',
        checkCondition: (userData) => userData?.questionsCorrect > 1000
    },










    {
        id: 'quiz_master',
        title: 'Quiz Master',
        description: 'Reach 1500 ELO',
        icon: '👑',
        checkCondition: (userData) => userData?.elo >= 1500
    },
    {
        id: 'quiz_god',
        title: 'Quiz God / Sebastian Jakobi',
        description: 'Reach 2000 ELO',
        icon: '👑',
        checkCondition: (userData) => userData?.elo >= 1500
    },




    {
        id: 'survivor',
        title: 'Survivor',
        description: 'Get a score of 25+ in Survival mode',
        icon: '☠️',
        checkCondition: (userData) => (userData?.scores?.Survival || 0) >= 25
    },
    {
        id: 'geography_expert',
        title: 'Geography Expert',
        description: 'Answer 50 flag questions correctly',
        icon: '🌍',
        checkCondition: (userData) => userData?.flagQuestionsCorrect >= 50
    },
    {
        id: 'winning_streak',
        title: 'Winning Streak',
        description: 'Win 5 ranked matches in a row',
        icon: '🔥',
        checkCondition: (userData) => userData?.winStreak >= 5
    },














    {
        id: 'flag_fanatic',
        title: 'Ferocious Flag Fanatic',
        description: 'Get Every Flag correct in the all flags quiz',
        icon: '🏴‍☠️',
        checkCondition: (userData) => (userData?.flagQuizScores?.all || 0) >= 248
    },
    {
        id: 'africa_flag_fan',
        title: 'Africa Flag Fan',
        description: 'Get Every Flag correct in the Africa flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.africa || 0) >= 50
    },
    {
        id: 'asia_flag_fan',
        title: 'Asia Flag Fan',
        description: 'Get Every Flag correct in the Asia flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.asia || 0) >= 49
    },
    {
        id: 'europe_flag_fan',
        title: 'Europe Flag Fan',
        description: 'Get Every Flag correct in the Europe flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.europe || 0) >= 50
    },
    {
        id: 'north_america_flag_fan',
        title: 'North America Flag Fan',
        description: 'Get Every Flag correct in the North America flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.['north-america'] || 0) >= 34
    },
    {
        id: 'south_america_flag_fan',
        title: 'South America Flag Fan',
        description: 'Get Every Flag correct in the South America flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.['south-america'] || 0) >= 12
    },
    {
        id: 'oceania_flag_fan',
        title: 'Oceania Flag Fan',
        description: 'Get Every Flag correct in the Oceania flags quiz',
        icon: '🏴',
        checkCondition: (userData) => (userData?.flagQuizScores?.oceania || 0) >= 24
    },










    {
        id: 'globetrotter',
        title: 'Globetrotter',
        description: 'Get Every Country correct in the world countries quiz',
        icon: '🏰',
        checkCondition: (userData) => (userData?.countryQuizScores?.all || 0) >= 174
    },
    {
        id: 'europe_explorer',
        title: 'Europe Explorer',
        description: 'Get Every Country correct in Europe country quiz',
        icon: '🏰',
        checkCondition: (userData) => (userData?.countryQuizScores?.europe || 0) >= 38
    },
    {
        id: 'asia_explorer',
        title: 'Asia Explorer',
        description: 'Get Every Country correct  in Asia country quiz',
        icon: '🗻',
        checkCondition: (userData) => (userData?.countryQuizScores?.asia || 0) >= 42
    },
    {
        id: 'oceania_explorer',
        title: 'Oceania Explorer',
        description: 'Get Every Country correct in Oceania country quiz',
        icon: '🏝️',
        checkCondition: (userData) => (userData?.countryQuizScores?.oceania || 0) >= 6
    },
    {
        id: 'africa_explorer',
        title: 'Africa Explorer',
        description: 'Get Every Country correct in Africa country quiz',
        icon: '🏝️',
        checkCondition: (userData) => (userData?.countryQuizScores?.africa || 0) >= 49
    },
    {
        id: 'na_explorer',
        title: 'North America Explorer',
        description: 'Get Every Country correct in North America country quiz',
        icon: '🏝️',
        checkCondition: (userData) => (userData?.countryQuizScores?.['north-america'] || 0) >= 16
    },
    {
        id: 'sa_explorer',
        title: 'South America Explorer',
        description: 'Get Every Country correct in South America country quiz',
        icon: '🏝️',
        checkCondition: (userData) => (userData?.countryQuizScores?.['south-america'] || 0) >= 12
    }
];

export const AchievementProvider = ({ children }) => {
    const { user, userData } = useUser();
    const [achievements, setAchievements] = useState([]);
    const [newAchievement, setNewAchievement] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [achievementQueue, setAchievementQueue] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [achievementStats, setAchievementStats] = useState({});
    const [totalUsers, setTotalUsers] = useState(0);

    // Use refs to track achievements being processed to prevent duplicates
    const processedAchievementsRef = useRef([]);

    // Ref to store timeout IDs for cleanup
    const timeoutRef = useRef(null);
    const popupTimeoutRef = useRef(null);

    // Ref to store unsubscribe function for real-time listener
    const unsubscribeRef = useRef(null);

    // Ref to store previous user data for comparison
    const prevUserDataRef = useRef(null);

    // Fetch achievement statistics
    useEffect(() => {
        const fetchAchievementStats = async () => {
            try {
                const usersRef = collection(db, "users");
                const querySnapshot = await getDocs(usersRef);
                
                const userCount = querySnapshot.size;
                setTotalUsers(userCount);
                
                const achievementCounts = {};
                
                // Initialize counts for all achievements
                ACHIEVEMENTS.forEach(achievement => {
                    achievementCounts[achievement.id] = 0;
                });
                
                // Count achievements across all users
                querySnapshot.forEach(doc => {
                    const userData = doc.data();
                    const userAchievements = userData.achievements || [];
                    
                    userAchievements.forEach(achievementId => {
                        if (achievementCounts[achievementId] !== undefined) {
                            achievementCounts[achievementId]++;
                        }
                    });
                });
                
                // Calculate percentages
                const stats = {};
                Object.keys(achievementCounts).forEach(achievementId => {
                    stats[achievementId] = {
                        count: achievementCounts[achievementId],
                        percentage: userCount > 0 ? (achievementCounts[achievementId] / userCount) * 100 : 0
                    };
                });
                
                setAchievementStats(stats);
            } catch (error) {
                console.error("Error fetching achievement statistics:", error);
            }
        };
        
        fetchAchievementStats();
        
        // Refresh stats periodically (every hour)
        const statsInterval = setInterval(fetchAchievementStats, 3600000);
        
        return () => clearInterval(statsInterval);
    }, []);

    // Load unlocked achievements initially and set up real-time listener
    useEffect(() => {
        if (user && user.uid) {
            // Set initial achievements from user data
            if (userData) {
                setAchievements(userData.achievements || []);
                // Reset processedAchievements when user data changes
                processedAchievementsRef.current = [];
                // Store initial user data for comparison
                prevUserDataRef.current = userData;
                // Initial check
                checkForNewAchievements();
            }

            // Set up real-time listener for the user document
            const userRef = doc(db, "users", user.uid);
            unsubscribeRef.current = onSnapshot(userRef, (docSnap) => {
                if (docSnap.exists()) {
                    const newUserData = docSnap.data();

                    // Check if any achievement-relevant fields have changed
                    const hasRelevantChanges = checkForRelevantChanges(prevUserDataRef.current, newUserData);

                    if (hasRelevantChanges) {
                        // Update previous data reference
                        prevUserDataRef.current = newUserData;
                        // Check for new achievements
                        checkForNewAchievements(newUserData);
                    }
                }
            }, (error) => {
                console.error("Error setting up real-time listener:", error);
            });

            // Cleanup function
            return () => {
                if (unsubscribeRef.current) {
                    unsubscribeRef.current();
                }
            };
        }
    }, [user]);

    // When a user unlocks a new achievement, update the global stats
    const updateAchievementStats = (achievementId) => {
        setAchievementStats(prev => {
            const prevStats = prev[achievementId] || { count: 0, percentage: 0 };
            const newCount = prevStats.count + 1;
            const newPercentage = totalUsers > 0 ? (newCount / totalUsers) * 100 : 0;
            
            return {
                ...prev,
                [achievementId]: {
                    count: newCount,
                    percentage: newPercentage
                }
            };
        });
    };

    // Check if any achievement-relevant fields have changed
    const checkForRelevantChanges = (oldData, newData) => {
        if (!oldData || !newData) return true;

        // Check for changes in scores
        if (JSON.stringify(oldData.scores) !== JSON.stringify(newData.scores)) {
            return true;
        }

        // Check for changes in countryQuizScores
        if (JSON.stringify(oldData.countryQuizScores) !== JSON.stringify(newData.countryQuizScores)) {
            return true;
        }

        // Check for changes in wins
        if (oldData.wins !== newData.wins) {
            return true;
        }

        // Check for changes in perfectScores
        if (oldData.perfectScores !== newData.perfectScores) {
            return true;
        }

        // Check for changes in elo
        if (oldData.elo !== newData.elo) {
            return true;
        }

        // Check for changes in flagQuestionsCorrect
        if (oldData.flagQuestionsCorrect !== newData.flagQuestionsCorrect) {
            return true;
        }

        // Check for changes in winStreak
        if (oldData.winStreak !== newData.winStreak) {
            return true;
        }

        return false;
    };

    // Process achievement queue when it changes
    useEffect(() => {
        // If queue has items and no popup is showing and not already processing
        if (achievementQueue.length > 0 && !showPopup && !isProcessing) {
            displayNextAchievement();
        }
    }, [achievementQueue, showPopup, isProcessing]);

    // Cleanup timeouts on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
            if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
            if (unsubscribeRef.current) unsubscribeRef.current();
        };
    });

    // Check if user has unlocked any new achievements
    const checkForNewAchievements = async (latestUserData = userData) => {
        if (!latestUserData || !user) return;

        const unlockedAchievements = latestUserData.achievements || [];
        const newlyUnlockedAchievements = [];

        // Check each achievement condition
        for (const achievement of ACHIEVEMENTS) {
            // Skip if already unlocked or was already processed this session
            if (unlockedAchievements.includes(achievement.id) ||
                processedAchievementsRef.current.includes(achievement.id)) continue;

            // Check if condition is met
            if (achievement.checkCondition(latestUserData)) {
                newlyUnlockedAchievements.push(achievement);
                // Add to processed list to avoid duplicate processing
                processedAchievementsRef.current.push(achievement.id);
                // Update achievement stats
                updateAchievementStats(achievement.id);
            }
        }

        // If there are new achievements, update Firestore and queue them
        if (newlyUnlockedAchievements.length > 0) {
            try {
                // Update all achievements in Firestore at once
                const userRef = doc(db, "users", user.uid);
                await updateDoc(userRef, {
                    achievements: arrayUnion(...newlyUnlockedAchievements.map(a => a.id))
                });

                // Update local state
                setAchievements(prev => [
                    ...prev,
                    ...newlyUnlockedAchievements.map(a => a.id)
                ]);

                // Add achievements to queue
                setAchievementQueue(prev => [...prev, ...newlyUnlockedAchievements]);
            } catch (error) {
                console.error("Error unlocking achievements:", error);
            }
        }
    };

    // Display the next achievement in the queue
    const displayNextAchievement = () => {
        if (achievementQueue.length === 0) return;

        // Mark as processing to prevent duplicate processing
        setIsProcessing(true);

        // Get the first achievement
        const achievement = achievementQueue[0];

        // Display it
        setNewAchievement(achievement);
        setShowPopup(true);

        // Set timeout to hide popup after 3 seconds
        popupTimeoutRef.current = setTimeout(() => {
            setShowPopup(false);

            // Set timeout to process next achievement after popup is hidden
            timeoutRef.current = setTimeout(() => {
                // Remove the processed achievement
                setAchievementQueue(prev => {
                    const newQueue = prev.slice(1);

                    // Reset processing state
                    setIsProcessing(false);

                    return newQueue;
                });
            }, 500);

        }, 3000);
    };

    // Check if an achievement is unlocked
    const isAchievementUnlocked = (achievementId) => {
        return achievements.includes(achievementId);
    };

    // Get achievement completion percentage
    const getAchievementStats = (achievementId) => {
        return achievementStats[achievementId] || { count: 0, percentage: 0 };
    };

    // Manually close the popup and process next achievement
    const closePopup = () => {
        // Clear any existing timeouts
        if (popupTimeoutRef.current) clearTimeout(popupTimeoutRef.current);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        setShowPopup(false);

        // Process next achievement after animation finishes
        timeoutRef.current = setTimeout(() => {
            setAchievementQueue(prev => {
                const newQueue = prev.slice(1);

                // Reset processing state
                setIsProcessing(false);

                return newQueue;
            });
        }, 300);
    };

    // For debugging - manually trigger achievements
    const debugUnlockAchievement = (achievementId) => {
        const achievement = ACHIEVEMENTS.find(a => a.id === achievementId);
        if (achievement && !isAchievementUnlocked(achievementId)) {
            setAchievementQueue(prev => [...prev, achievement]);
        }
    };

    // Context value
    const value = {
        achievements,
        newAchievement,
        showPopup,
        isAchievementUnlocked,
        checkForNewAchievements,
        closePopup,
        ACHIEVEMENTS,
        debugUnlockAchievement, // Expose debug function if needed
        getAchievementStats, // Expose method to get achievement stats
        achievementStats, // Expose all achievement stats
        totalUsers // Expose total user count
    };

    return (
        <AchievementContext.Provider value={value}>
            {children}
        </AchievementContext.Provider>
    );
};

// Custom hook for using the Achievement context
export const useAchievement = () => {
    const context = useContext(AchievementContext);
    if (context === undefined) {
        throw new Error("useAchievement must be used within an AchievementProvider");
    }
    return context;
}; 